import * as React from 'react';
import { ValidationList } from './ValidationList';
import styled from 'styled-components';
import { Card } from '../Card';
import { Header2Text } from '../Typography';
import { NewOrderSpaceWrapping } from '../../../components/orderCreation/wrappers/NewOrderSpaceWrapper';
import { useFormikContext } from 'formik';
import { transformFormikValidation } from '../../../components/orderCreation/utilities/transformFormikValidation';
import { INewOrderSchema } from '../../../components/orderCreation/validation/NewOrderSchema';
import { useMemo } from 'react';
import { ICreateOrderRequest } from '../../orders/interfaces/createOrder/ICreateOrderRequest';

const ValidationCard = styled(Card)`
  border: solid 1px ${(props) => props.theme.colors.error};
  border-radius: ${(props) => props.theme.spacing.spacing2};
  display: grid;
  gap: ${(props) => props.theme.spacing.spacing5};
`;

export const ValidationSummary: React.FC = () => {
  const { isValid, submitCount, errors, values } = useFormikContext<ICreateOrderRequest>();
  const results = useMemo(() => transformFormikValidation(errors, values as INewOrderSchema), [errors, values]);

  if (isValid || submitCount === 0) {
    return null;
  }
  return (
    <NewOrderSpaceWrapping>
      <ValidationCard>
        <Header2Text>{'Unable to create order due to the following errors'}</Header2Text>
        <ValidationList items={results} />
      </ValidationCard>
    </NewOrderSpaceWrapping>
  );
};
